module.exports = "/static/assets/e3077ea26cf0fc3393020f2cc3f87119.png";